var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-content',[_c('v-container',{attrs:{"fluid":this.$vuetify.breakpoint.mdAndDown}},[(_vm.$store.state.adminToken)?[_c('admin-nav'),_c('v-card',{staticClass:"pa-4"},[_c('router-view')],1)]:_c('login')],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }